// action
import {
    SAVE_QUICK_SUPPORT_CATEGORY,
    SAVE_QUICK_SUPPORT_CATEGORY_FAIL,
    SAVE_QUICK_SUPPORT_CATEGORY_SUCCESS,
    SAVE_QUICK_SUPPORT_CATEGORY_RESET
} from '../action/saveQuickSupportCategoryAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_QUICK_SUPPORT_CATEGORY:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_QUICK_SUPPORT_CATEGORY_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_QUICK_SUPPORT_CATEGORY_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_QUICK_SUPPORT_CATEGORY_RESET:
            return initialState
        default:
            return state
    }
}